module.exports = __webpack_public_path__ + "img/FD.99bd8a30.png";